import React, { Component } from "react";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore
} from "react-toasts";
import ReportTable from "./ReportTable";
import { callApi } from "../../utils/api";
import _ from "lodash";
import { hasPageAccess } from "../../utils/pagePermissionService";
import QueryvalidationReporttable from "./QueryvalidationReporttable";
declare var $: any;

interface AllProps {
  match: any;
  history: any;
  location: any;
}

export default class QueryValidationReport extends Component<AllProps> {
  state = {
    outreason: "",
    selectVal: false,
    searchText: "",
    reports: [] as any[],
    filteredReports: [] as any[],
    lawhandsBranches: [] as any[],
    status_id: "",
    type: "",
    isLoading: false
  };

  async componentDidMount() {
    this.getLawHandsBranches();
    this.getOutTime();
    const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
    if (!hasHide) {
      this.ouTime();
    }
  }

  getOutTime = () => {
    let date = new Date();
    let stratTime = date.getTime();
    localStorage.setItem("startTime", JSON.stringify(stratTime));
    let outDate = date.toLocaleDateString();
    localStorage.setItem("OutDateGet", JSON.stringify(outDate));
    var Railway = date.getMinutes();
    if (Railway < 10) {
      var TotalMinutes = "0" + Railway;
      let ouTtime = date.getHours() + ":" + TotalMinutes;
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    } else {
      let ouTtime: any = date.getHours() + ":" + date.getMinutes();
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    }
  };

  ouTime = () => {
    if (localStorage.getItem("currentfileId")) {
      $("#out_reason").modal("show");
    }
  };

  getLawHandsBranches() {
    callApi("GET", "get_branch.php")
      .then((res) => res.data)
      .then((response) => {
        this.setState({ lawhandsBranches: response.data || [] }, () => {
          const status = this.props.match.params.id;
          const type = this.props.match.params.type;
          this.getQueryValidationReport(status, type);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  redirectToDashboard = (id: number) => {
    if (id !== undefined) {
      let obj = { id };
      let status = this.state.status_id;
      let type = this.state.type;
      const url = `/query-validation-report/${type}/${status}`;
      localStorage.setItem("url", url);
      localStorage.setItem("thisPopup", JSON.stringify(obj));
      localStorage.setItem("currentfileId", JSON.stringify(id));
      this.props.history.push("/file-dashboard/" + id);
    }
  };

  getQueryValidationReport(status: string, type: string) {
    const { state } = this.props.history.location;
    const filterData = state && state.filterData;
    this.setState({ status_id: status, type });
    let payload: any = {
      status,
      type
    };
    if (filterData != null && filterData !== undefined) {
      payload = { ...payload, ...filterData };
    }
    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    payload = {
      ...payload,
      roleId: userDetails ? userDetails.role_id : null,
      userId: userDetails ? userDetails.userId : null,
      roleType: userDetails ? userDetails.roleType : null
    };
    callApi("POST", "query_validation_subreport.php", payload)
      .then((res) => res.data)
      .then((result) => {
        if (result.result === true && Array.isArray(result.data)) {
          const data = result.data.map((item: any, index: number) => ({
            ...item,
            serial: index + 1
          }));
          this.setState({ reports: data, filteredReports: data });
        } else {
          this.setState({ reports: [], filteredReports: [] });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ reports: [], filteredReports: [] });
      });
  }

  getBankBrancheById = (id: number) => {
    const branches = this.state.lawhandsBranches;
    const branch = _.filter(branches, ["id", id])[0];
    return branch === undefined ? "" : branch.name;
  };

  handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { reports } = this.state;
    const val = e.target.value;
    const list = reports.filter((item: any) => {
      const fileId = (item.file_name || item.id || "").toString().toLowerCase();
      return fileId.includes(val.toLowerCase());
    });
    this.setState({
      searchText: val,
      filteredReports: list
    });
  };

  render() {
    const { filteredReports, selectVal } = this.state;
    return (
      <section className="policymain-container complaint-box">
        <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-header">
                          <h4>
                            <b>Query Validation Report</b>
                            <button
                              className="btn btn-primary"
                              style={{ float: "right" }}
                              onClick={() => this.props.history.goBack()}
                            >
                              Back
                            </button>
                          </h4>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="dt-responsive table-responsive">
                              <QueryvalidationReporttable
                                redirectToDashboard={this.redirectToDashboard}
                                reports={filteredReports}
                                getBranch={this.getBankBrancheById}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
